import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useEffect, useRef, useState } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RpmGraphs from '../tabs/rpmgraphs';
import api from '../../api/api';
import NoteView from './NoteView';
import CallIcon from '@mui/icons-material/Call';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { Backdrop, CircularProgress } from '@mui/material';
import ToastMessage from "../../utils/mui/righttoptoast";
import { useSelector } from 'react-redux';
import { getPracticeId, patientPhotoUrl } from '../../config/practice';
const RpmCard = ({ isOpen, onClose, selectedCard}) => {
  const [loading, setLoading] = useState(false);
  const [showList, setShowList] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [notes,setNotes]=useState([])
  const userConfig = useSelector((state) => state.userconfig)
  const [isLoader,SetIsLoader]=useState(false)
  const [dataLoading, setDataLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [createNotes, setCreateNotes] = useState([]);
  const [Textnote,setTextnote]=useState('')
  const [Notetime,setNoteTime]=useState('')
 const [selectedMedications, setSelectedMedications] = useState([]);
  const [alertmessage, setAlertMessage] = useState('');
  const [severity, setSeverity] = useState('success');
  const [open, setOpen] = useState(false);
  const [reviewed,setreviewed]=useState()
  const [fallowup,setFallowup]=useState()
  const [callback,setcallback]=useState()
 const [showMedication, setShowMedication] = useState(false);
  const practiseid = getPracticeId();
const [medicationData,setMedicationData]=useState([])
    const tabs = [
      { label: "BPP" },
      { label: "WLM" }
    ];
  const [selectedTab, setSelectedTab] = useState(0);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const onSelectTab = (index) => {
    setSelectedTab(index);
  };
  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };
 const handlealert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  useEffect(()=>{
    if(isOpen){
      fetchRpmNote(selectedCard)
    }
  },[isOpen])
 const fetchMedicationData=async()=>{
  try {
    SetIsLoader(true)
    const response=await api.get(`/v1/${practiseid}/medications/patient/${selectedCard.patientid}/review/99999`)
    if(response.status==200){
      setMedicationData(response?.data||[])
    }else{
      setMedicationData([])
    }
  } catch (error) {
    console.log(error)
  }finally{
SetIsLoader(false)
  }


 }
 
  const fetchRpmNote = async (selectedCard) => {
    setDataLoading(true); // Set data loading to true
    try {
      console.log('Fetching data for patient ID:', selectedCard.patientid); // Log the patient ID for debugging
      const response = await api.get(`/v1/${practiseid}/patient/${selectedCard.patientid}/rpm/patient-notes`);
    // 
      if (response.status === 200) {
        setNotes(response.data);
        console.log('Fetched Notes:', response.data); // Log fetched data
      } else {
        setNotes([]);
      }
    } catch (error) {
      console.log('Error fetching data:', error);
      setNotes([]); // If error occurs, reset the notes
    } finally {
      setDataLoading(false); // Set data loading to false
    }
  };

 
  
   
  const fetchCreateNote = async (selectedCard) => {
    setDataLoading(true); // Set data loading to true
    try {
      console.log('Fetching data for patient ID:', selectedCard.patientid); // Log the patient ID for debugging
      const response = await api.post(`/v1/${practiseid}/patient/${selectedCard.patientid}/rpm/create-patient-notes`,{
        "notes": Textnote,
        "category": "ALL",
        "created_by": `${selectedCard?.firstname} ${selectedCard?.lastname}`,
        "type": "rpminternal",
        "tat": Notetime,
        "status": 1
      });
    // 
      if (response.status === 200) {
        setCreateNotes(response.data);
        console.log('Fetched Notes:', response.data); // Log fetched data
      } else {
        setCreateNotes([]);
      }
    } catch (error) {
      console.log('Error fetching data:', error);
      setCreateNotes([]); // If error occurs, reset the notes
    } finally {
      fetchRpmNote(selectedCard)
      setDataLoading(false); // Set data loading to false
    }
  };

const approvemedications=async()=>{
  try {
    
  let unchecked = [];

if (medicationData.length > 0 && selectedMedications.length > 0) {
  unchecked = medicationData
    .filter(
      (med) =>
        !selectedMedications.some(
          (selected) => selected.medicationid === med?.medicationid
        )
    )
    .map((med) => med?.medicationid);
} else {
  unchecked = [];  // Fallback to empty array
}  
    setLoading(true)
   

   if (unchecked.length === 0) {
  unchecked.push(2413);
}

    const response =await api.post(`/v1/${practiseid}/intake/patient/${selectedCard.patientid}/refills/approve`,{
        "patient_name": "raju",
  "medslist":  selectedMedications.map(item => item.medication).join(', '),
  "uncheckActive":unchecked,
  login_user:userConfig.username
    })
    if(response.status==200){
     setAlertMessage('Medications Approved Successfully');
          setSeverity('success');
          setOpen(true);
          setSelectedMedications([])
    }else{
     setAlertMessage(response?.message||'Something went Wrong');
          setSeverity('info');
          setOpen(true);
    }
  } catch (error) {
    console.log(error)
    setAlertMessage('Something went Wrong');
          setSeverity('error');
          setOpen(true);
  }finally{
setLoading(false)
  }
}
  const fetchfallowup = async () => {
    const category = selectedTab === 0 ? "bpp" : "wlm";
    const type = selectedTab === 0 ? "BPPFollowup" : "WLMFollowup";

    try {
      const response = await api.post(`/v1/${practiseid}/patient/${selectedCard.patientid}/rpm/mark-followup`, {
        category,
        type,
        "tat": 2,
        "status": 1,
        "created_by": `${selectedCard?.firstname} ${selectedCard?.lastname}`
      }
      );

      if (response.status === 200) {
        setFallowup(response); // Assuming response data is an array of WLM readings
        console.log('Fetched WLM Data:', response);
        // fetchRpmNote(selectedCard)

      } else {
        setFallowup(); // Reset the data if the response is not successful
      }
    } catch (error) {
      console.log('Error fetching WLM data:', error);
      setFallowup(); // Reset data in case of error
    } finally {
    }
  };


  const fetchreviewed = async () => {
    const category = selectedTab === 0 ? "bpp" : "wlm";
    const type = selectedTab === 0 ? "BPPReviewed" : "WLMReviewed";
    try {
      const response = await api.post(`/v1/${practiseid}/patient/${selectedCard.patientid}/rpm/mark-reviewed`, {
        category,
        type,
        "tat": 2,
        "status": 1,
        "created_by": `${selectedCard?.firstname} ${selectedCard?.lastname}`
      });

      if (response.status === 200) {
        setreviewed(response); // Assuming response data is an array of WLM readings
        console.log('Fetched WLM Data:', response);
      
        // fetchRpmNote(selectedCard)
      } else {
        setreviewed(); // Reset the data if the response is not successful
      }
    } catch (error) {
      console.log('Error fetching WLM data:', error);
      setreviewed(); // Reset data in case of error
    } finally {
    }
  };
 const markmedication=async(id,type)=>{
  try {
    setLoading(true)
    const response=await api.put(`/v1/${practiseid}/intake/refills/update`,{
        "id":id,
  "changeVal": type,
  "type": 1
    })
    if(response.status==200){
fetchMedicationData()
    }else{
      
    }
  } catch (error) {
    console.log(error)
  }finally{
    setLoading(false)
  }
 }
  const fetchcallback = async () => {
    const category = selectedTab === 0 ? "bpp" : "wlm";
    const type = selectedTab === 0 ? "BPPCallBack" : "WLMCallBack";

    try {
      const response = await api.post(`/v1/${practiseid}/patient/${selectedCard.patientid}/rpm/mark-callback`, {
        category,
        type,
        "tat": 2,
        "status": 1,
        "created_by": `${selectedCard?.firstname} ${selectedCard?.lastname}`
      });

      if (response.status === 200) {
        setcallback(response); // Assuming response data is an array of WLM readings
        console.log('Fetched WLM Data:', response);
        // fetchRpmNote(selectedCard)

      } else {
        setcallback(); // Reset the data if the response is not successful
      }
    } catch (error) {
      console.log('Error fetching WLM data:', error);
      setcallback(); // Reset data in case of error
    } finally {
    }
  };
  const handleActionChange = (e) => {
    const selectedAction = e.target.value;
  
    if (!selectedAction) return; // If no action is selected, do nothing.
  
    switch (selectedAction) {
      case "reviewed":
        fetchreviewed(); // Calls the fetchreviewed function
        break;
      case "followup":
        fetchfallowup(); // Calls the fetchfallowup function
        break;
      case "callback":
        fetchcallback(); // Calls the fetchcallback function
        break;
      default:
        break;
    }
  };
  // /v1/{{practiceid}}/patient/7114/rpm/create-patient-notes
  if (!isOpen) return null;
  const toggleList = () => {
    setShowList(!showList);
  };
  const deviceButtons = selectedCard?.device_mast?.slice(0, showAll ? undefined : 3) || [];
  return (
    <div className="fixed z-50 flex items-center justify-center lg:h-[100vh] h-[100%]  w-full custom-scrollbar bg-black bg-opacity-50 top-16 ">
      <div className="bg-white shadow-lg w-full h-full relative  mb-4 " >
        {/* Header Section */}
        <div className="flex justify-between items-center border-b p-2 ">
          <div className="text-lg font-semibold flex">
          <div className="flex flex-col px-2 rounded-md gap-4">
              <div className="flex items-center gap-4">
                <img
                  src={patientPhotoUrl(selectedCard?.patientid)}
                  alt="profile"
                   onError={(e) =>
                    (e.target.src =
                      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")
                  }
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div className="flex flex-col font-semibold text-[14px] text-start gap-2">
                  <div className='flex gap-2'>
                  <div className='text-[15px]'>{`${selectedCard?.firstname} ${selectedCard?.lastname}`}</div>
                  <div className="px-2 text-xs items-center flex align-center rounded-full  bg-[#E179541A] text-[#E17954] ">#{selectedCard?.patientid}</div>
                  </div>
                  <div className='text-xs text-[#6B7280]'> <CallIcon style={{width:"14px",marginRight:'2px'}}/>{selectedCard?.phone}</div>

                </div>
              </div>
            </div>
          </div>
                   <div className='flex'>
                   <div className='flex flex-column mr-10 '>
                   <div className="px-2 font-semibold py-1 inline-block rounded-sm  text-violet-800">
                   <div className='text-xs'>{new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' })}</div>                  </div>
                  <div className='color-[#6B7280] text-[10px] font-semibold'>
                    Last updated: 2 hours ago
                  </div>
                   </div>
                
                  <button
            className="text-black"
            onClick={() => onClose(false)}
          >
            <CloseIcon  />
          </button>
          </div>
         
        </div>
        {/* Content Divided into Columns */}
        <div className="flex flex-col lg:flex-row lg:h-[85vh] h-[88%]  overflow-y-auto custom-scrollbar pb-2">
          <div className="w-full lg:w-9/12 p-4 "> 
       
           <RpmGraphs selectedCard={selectedCard} notes={notes} fetchRpmNote={fetchRpmNote} selectedTab={selectedTab} setSelectedTab={setSelectedTab} tabs={tabs}/>
          </div>

          {/* Right Column */}
          <div className="w-full lg:w-3/12 p-2 flex flex-col gap-2 border-gray-300">
            {/* Patient Details */}
          

            {/* Billing Section */}
            <div className='border-[1.5px] border-gray-200 rounded-xl p-2 px-3'>
              <label className="block text-gray-700 text-[13px] font-Geist font-semibold mb-2 text-left ">BILLING</label>
              <div className="flex gap-2">
              <button className="px-3 py-1 bg-[#FFF7ED] text-sm font-semibold rounded-sm">
                {(() => {
                  const bppArray = selectedCard?.BPP || []; // default to empty array
                  const uniqueDates = new Set(
                    bppArray.map(item => item.datetime.split(' ')[0])
                  );
                  return uniqueDates.size;
                })()} Bpp
              </button>

              <button className="px-3 py-1 bg-[#FFF7ED] text-sm font-semibold rounded-sm">
              {(() => {
                  const bppArray = selectedCard?.BPP || [];
                  const wlmArray = selectedCard?.WLM || [];
      const bppUniqueDates = new Set(
        bppArray.map(item => item.datetime.split(' ')[0])
      );
      const wlmUniqueDates = new Set(
        wlmArray.map(item => item.datetime.split(' ')[0])
      );
      const combinedUniqueDates = new Set([...bppUniqueDates, ...wlmUniqueDates]);
      return combinedUniqueDates.size;
      })()
      } Total</button>
      <button className="px-3 py-1 bg-[#FFF7ED] text-sm font-semibold rounded-sm"> {selectedCard?.tat}   minutes </button>
              </div>
            </div>

            {/* Notes Section */}
            <div className='border-[1.5px] border-gray-200 p-2 rounded-xl'>
              <div className='flex justify-between w-full'>
              <label className="block text-gray-700 text-[13px] font-Geist font-semibold mb-1 text-left">Notes</label>
         
        <div className="flex flex-col gap-4 mb-1">
        <div className="flex gap-4 justify-center flex-column">
  <select
    onChange={handleActionChange} // Triggers the function on change
    className="px-2 py-1 bg-gray-40 text-sm rounded-sm border-[1.2px] border-[#ccc] w-full"
    defaultValue="" // Default value set to empty so that it starts with "Select Action"
  >
    <option value="" disabled>Select Action</option>
    <option value="reviewed">Mark as Reviewed</option>
    <option value="followup">Mark as Need Follow-Up</option>
    <option value="callback">Mark as Needs Call Back</option>
  </select>
</div>
       </div>

              </div>
              <textarea onChange={(e)=>setTextnote(e.target.value)} value={Textnote}
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                placeholder="Enter your notes..."
                rows="4"
              ></textarea>
              <div className="flex justify-start mt-1 gap-2 ">
                <button onClick={()=>fetchCreateNote(selectedCard)}
                  className="px-1 py-1 flex items-center justify-center w-[100px]  align-center text-sm rounded-lg bg-orange-500 text-white"
                  aria-label="Add"
                >
                  + Notes
                </button>
                <select
                    name="timeSpent"
                    onChange={(e)=>setNoteTime(e.target.value)}
                    value={Notetime}
                    className={`w-full px-4 py-2 text-xs border rounded-md focus:ring focus:ring-blue-300 outline-none`}
                  >
                    <option value="">Select Time</option>
                    {[...Array(21).keys()].map((i) => (
                      <option key={i} value={i}>
                        {i} minute{i > 1 ? "s" : ""}
                      </option>
                    ))}
                  </select>
                {isModalOpen && (
                    <NoteView selectedCard={selectedCard} notes={notes} dataLoading={dataLoading} closeModal={closeModal}/>
                 )}

              </div>
            </div>
<div className='flex justify-start'>
<div
  onClick={() => {
    if (!showMedication) {
      fetchMedicationData();
    }
    setShowMedication(!showMedication);
  }}
  className="rounded-md bg-[#16A34A] text-white px-2 text-xs py-1 cursor-pointer flex items-center gap-1"
>
  {showMedication ? 'Hide Medication' : 'Show Medications'}
  <FontAwesomeIcon icon={showMedication ? faChevronUp : faChevronDown} />
</div>
</div>
{showMedication ? (
  <div className="max-h-64 min-h-36 overflow-y-auto border rounded p-2">
 {medicationData && medicationData.length > 0 ? (
  medicationData.map((med, index) => {
    const isChecked = selectedMedications.some(item => item.medication === med?.medication);
    const isRefillChecked = med.refil === 'Y';

    return (
      <div key={index} className="flex items-center justify-between gap-2 py-1">
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            id={`med-${index}`}
            checked={isChecked}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedMedications(prev => [...prev, med]);
              } else {
                setSelectedMedications(prev =>
                  prev.filter(item => item.medication !== med?.medication)
                );
              }
            }}
          />
          <label htmlFor={`med-${index}`} className="text-sm">
            {med?.medication}
          </label>
        </div>

        <input
          type="checkbox"
          checked={isRefillChecked}
          onClick={() =>{
            let ischecked =med.refil === 'Y'?'False':'true'
            markmedication(med.id,ischecked)}}
          readOnly
        />
      </div>
    );
  })
) : (
  <div className="text-gray-500 text-sm italic">No medications found.</div>
)}


  </div>
) : null}

<div className=''>{selectedMedications.length?<div
onClick={()=>{approvemedications()}}
className='bg-[#E17954] cursor-pointer px-2 py-1 rounded-md text-xs text-white'>Approve</div>:<></>}</div>


            {/* Scrollable Table */}
            <div className='border-[1.5px] border-gray-200 rounded p-2 '>
              <div className='flex w-full justify-between'>
              <p className='text-start text-[13px] font-Geist font-semibold'>Review History</p>  
                 <div className='flex'>
              <div
                  className=" text-[#71717A] text-xs cursor-pointer font-font1"
                  aria-label="View"
                  onClick={openModal}
                >
                  View All
                </div>
              </div>
              </div>
             <div className='max-h-[250px] overflow-y-auto ' style={{scrollbarWidth:'none'}}>
              <table className="min-w-full bg-white border border-gray-300 text-xs text-left text-gray-700 ">
               
              <tbody>
  {dataLoading ? (
    <tr>
      <td colSpan="2" className="px-2 py-1 text-center">
        <div className="flex justify-center items-center">
          <div className="w-6 h-6 border-4 border-t-4 border-blue-500 border-solid rounded-full animate-spin"></div>
        </div>
        Loading...
      </td>
    </tr>
  ) : notes.length > 0 ? (
    notes.map((note, index) => (
      <tr key={index} className="hover:bg-gray-50 bg-[#F9FAFB]">
        <td className="px-2 py-1 border-b font-semibold text-[#4B5563]">
        <span style={{ color: '#E17954',fontWeight:"bold" }}>
    {note.created_at}
        </span>

        <div className='text-black'>
            {note.notes.replace(/<[^>]+>/g, '')}
        </div>
          <br/>Reviewed by {note.created_by} on {note.reviewDate}
        
        </td>
        <td className="px-2 py-1 border-b text-[#E17954]"><span className='px-2 py-1 bg-[#E179541A] font-semibold rounded-lg'>{note.category}</span></td>

      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="2" className="px-2 py-1 text-center">No notes available</td>
    </tr>
  )}
</tbody>

              </table>
              </div>
            </div>
          </div>
        </div>
      </div>
        <Backdrop
                             sx={{
                               color: 'secondary.main', // Sets the CircularProgress color to secondary
                               backgroundColor: 'rgba(255, 255, 255, 0.5)', // Semi-transparent white background
                               zIndex: (theme) => theme.zIndex.drawer + 1
                             }}
                             open={isLoader}
                           >
                             <CircularProgress color="secondary" />
                           </Backdrop>
                            <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handlealert} />
    </div>
  );
};

export default RpmCard;
